var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1110_53694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.725 2.62109H2.45841C1.20372 2.62109 0.183594 3.48863 0.183594 4.55469C0.183594 5.62117 1.20372 6.48828 2.45841 6.48828H17.725C18.9791 6.48828 19.9998 5.62117 19.9998 4.55469C19.9998 3.48863 18.9791 2.62109 17.725 2.62109Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.725 9.06641H2.45841C1.20372 9.06641 0.183594 9.93395 0.183594 11C0.183594 12.0665 1.20372 12.9336 2.45841 12.9336H17.725C18.9791 12.9336 19.9998 12.0665 19.9998 11C19.9998 9.93395 18.9791 9.06641 17.725 9.06641Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.725 15.5117H2.45841C1.20372 15.5117 0.183594 16.3793 0.183594 17.4453C0.183594 18.5118 1.20372 19.3789 2.45841 19.3789H17.725C18.9791 19.3789 19.9998 18.5118 19.9998 17.4453C19.9998 16.3793 18.9791 15.5117 17.725 15.5117Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1110_53694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.bafc88b1353e4637471da88d7aa9c7a0.svg";
export { ForwardRef as ReactComponent };